document.addEventListener("DOMContentLoaded", initMushroomButtons);
function scrollIntoMushroomBlock(mushroomBlockId) {
  document.getElementById(mushroomBlockId)?.scrollIntoView({
    behavior: "smooth",
    inline: "center",
    block: "nearest",
  });
}

function initMushroomButtons() {
  const mushroomButtons = document.querySelectorAll(
    "ul.mushroom-button-list li button"
  );
  mushroomButtons.forEach((button) => {
    const mushroomBlockId = button.getAttribute("aria-controls");
    button.addEventListener("click", () =>
      scrollIntoMushroomBlock(mushroomBlockId)
    );
  });
}
